module.exports = __webpack_public_path__ + "img/close-circle.a6f0e553.png";